module.exports = __webpack_public_path__ + "img/snowboarding1.69db1e92.jpg";